import NoDataImage from '../../assets/icons/no-data.svg';
import { NoDataProps } from '../../types';
import './NoData.scss';

const NoData = ({ image = NoDataImage, message, actionText, action, theme = 'light', title }: NoDataProps) => {
  return (
    <div className="no-data">
      <div className="no-data__content">
        {image && <img src={image} alt="" />}
        {title && <h1>{title}</h1>}
        <p>{message}</p>
        {actionText && action && (
          <button className={theme} onClick={action}>
            {actionText}
          </button>
        )}
      </div>
    </div>
  );
};

export default NoData;
